interface Props {
  searchTerm: string;
  onSearchChange: (v: string) => void;
  activeStatus: string;
  onStatusChange: (v: string) => void;
  activeHierarchy: string;
  onHierarchyChange: (v: string) => void;
  statusCounts: Record<string, number>;
}

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Activos' },
  { value: 'disabled', label: 'Inactivos' },
];

const HIERARCHY_OPTIONS = [
  { value: 'all', label: 'Todos los niveles' },
  { value: '1', label: 'Nivel 1 — Sistema' },
  { value: '2', label: 'Nivel 2 — Plataforma' },
  { value: '3', label: 'Nivel 3 — Operaciones' },
  { value: '4', label: 'Nivel 4 — Propietario' },
  { value: '5', label: 'Nivel 5 — Administración' },
  { value: '6', label: 'Nivel 6 — Staff' },
  { value: '7', label: 'Nivel 7 — Creador' },
  { value: '8', label: 'Nivel 8 — Usuario' },
];

export default function RoleFilters({
  searchTerm,
  onSearchChange,
  activeStatus,
  onStatusChange,
  activeHierarchy,
  onHierarchyChange,
  statusCounts,
}: Props) {
  const hasFilters = activeStatus !== 'all' || activeHierarchy !== 'all' || searchTerm.trim().length > 0;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      {/* Search */}
      <div className="relative flex-1 max-w-sm">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <i className="ri-search-line text-foreground-400 text-sm"></i>
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar rol por nombre o descripción..."
          className="w-full pl-9 pr-10 py-2.5 rounded-xl bg-background-50 border border-background-200 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-background-300 focus:ring-2 focus:ring-primary-100 transition-all"
        />
        {searchTerm && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer hover:text-foreground-600 text-foreground-400 transition-colors"
          >
            <i className="ri-close-circle-line text-sm"></i>
          </button>
        )}
      </div>

      {/* Status chips */}
      <div className="flex items-center gap-1.5 bg-background-50 border border-background-200 rounded-xl p-1">
        {STATUS_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            onClick={() => onStatusChange(opt.value)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium cursor-pointer transition-all whitespace-nowrap ${
              activeStatus === opt.value
                ? 'bg-foreground-950 text-background-50'
                : 'text-foreground-500 hover:bg-background-100 hover:text-foreground-700'
            }`}
          >
            {opt.label}
            {opt.value !== 'all' && statusCounts[opt.value] !== undefined && (
              <span className={`ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold ${activeStatus === opt.value ? 'bg-background-50/20 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                {statusCounts[opt.value]}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Hierarchy select */}
      <div className="relative">
        <select
          value={activeHierarchy}
          onChange={(e) => onHierarchyChange(e.target.value)}
          className="appearance-none pl-3 pr-8 py-2.5 rounded-xl bg-background-50 border border-background-200 text-foreground-800 text-sm cursor-pointer focus:outline-none focus:border-background-300 transition-all"
        >
          {HIERARCHY_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-2.5 pointer-events-none">
          <i className="ri-arrow-down-s-line text-foreground-400 text-sm"></i>
        </div>
      </div>

      {/* Clear filters */}
      {hasFilters && (
        <button
          onClick={() => {
            onSearchChange('');
            onStatusChange('all');
            onHierarchyChange('all');
          }}
          className="flex items-center gap-1 px-3 py-2.5 rounded-xl text-xs font-medium text-foreground-500 bg-background-50 border border-background-200 cursor-pointer hover:bg-background-100 hover:text-foreground-700 transition-all whitespace-nowrap"
        >
          <i className="ri-filter-off-line text-sm"></i>
          Limpiar filtros
        </button>
      )}
    </div>
  );
}